import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export const useCallingPipelineList = () => {
  const axios = useAxios();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const params: Record<string, string> = {};
  const callOutcome = searchParams.get("callingStatus");
  const enableDnd = searchParams.get("doNotDisturb");
  const lastCallAttempted = searchParams.get("lastCall");
  const callAttempts = searchParams.get("callAttempts");
  const myVault = searchParams.get("myVault");
  const myCheckout = searchParams.get("myCheckout");
  const hasCallbackScheduled = searchParams.get("hasCallback");
  const sortBy = searchParams.get("sortBy");

  if (callOutcome) params.callOutcome = callOutcome;
  if (enableDnd) params.enableDnd = enableDnd;
  if (lastCallAttempted) params.lastCallAttempted = lastCallAttempted;
  if (callAttempts) params.callAttempts = callAttempts;
  if (hasCallbackScheduled) params.hasCallbackScheduled = hasCallbackScheduled;
  if (myVault) params.myVault = myVault;
  if (myCheckout) params.myCheckout = myCheckout;
  if (sortBy) params.sortBy = sortBy;

  return useQuery({
    queryKey: ["calling-pipeline-list", searchParams.toString()],
    queryFn: async () => {
      const urlKey = t("calling-pipeline-listing");
      const response = await axios.get(urlKey, { params });
      return response.data.data;
    },
    refetchOnWindowFocus: false
  });
};
